/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import birdata from "../api.js";
import h from "util/dom-builder.js";
import util from "../util/util.js";

document.addEventListener('DOMContentLoaded', populateStats);

function createEventBus() {
	var subscribers = [];
	function sub(name, handler, thisArg) {
		subscribers.push({ name, handler, thisArg });
	}
	function pub(name) {
		var args = Array.prototype.slice.call(arguments, 1);
		subscribers.forEach(function(sub) {
			if(sub.name === name) {
				sub.handler.apply(sub.thisArg, args);
			}
		});
	}

	return { subscribers, pub, sub };
}

var eventBus = createEventBus();

function select(options, onChange) {
	return h("select", { "$change": onChange }, options.map(function(o) {
		return h("option", { value: o.value }, o.title)
	}));
}

function stateOptions(states) {
	return [{ title: "Australia", value: "" }].concat(states.map(function(s) {
			return {
				title: s.name,
				value: s.id
			}
		}
	));
}

function populateStats() {
	document.querySelectorAll(".birdata-stat").forEach(el => {
		var stat = el.getAttribute("data-stat");

		var options = {};
		[].forEach.call(el.attributes, function(attr) {
			if(/^data-/.test(attr.name)) {
				var name = attr.name.substr(5).replace('-', '_');
				if(name !== "stat") {
					options[name] = attr.value;
				}
			}
		});

		if(stat === 'state_menu') {
			// Show a dropdown menu to select state
			el.innerHTML = '&nbsp;';
			birdata.areas({ layer: "state" }).then(function(states) {
				var regionSelect = select(stateOptions(states), function() {
					eventBus.pub("state-selected-" + options.menu_name, regionSelect.value);
				});
				el.appendChild(regionSelect);
			});
		} else if(stat === 'top_observers') {
			// Show top observers with integrated menus for state and time period
			birdata.areas({ layer: "state" }).then(function(states) {
				function onChange() {
					var params = { period: periodSelect.value };
					if(regionSelect.value) {
						params.area_id = regionSelect.value;
					}
					resultsEl.innerHTML = 'Loading...';

					birdata.stats("active_observers", params).then(function(result) {
						resultsEl.innerHTML = '';
						resultsEl.appendChild(h("ul", result.top_observers_with_counts.map(function(user) {
							return h("li", user.name + " – " + util.formatQuantity(user.survey_count, "survey") + ", " + util.formatQuantity(user.species_count, "species", "species"));
						})));
					});
				}

				var resultsEl = h("div", { style: "min-height: 10em;" });

				var periodSelect = select([
					{ title: "this month", value: "this_month" },
					{ title: "this year", value: "this_year" }], onChange);

				var regionSelect = select(stateOptions(states), onChange);

				el.innerHTML = '';
				el.appendChild(h("h2", { "class": "top-observers-heading" }, [
					"Top observers ",
					periodSelect,
					" in ",
					regionSelect
				]));
				el.appendChild(resultsEl);

				onChange();
			});

		} else if(options.state_menu) {
			// Show an individual stat linked to a state menu
			(function() {
				var cancel = function() {};
				function onChange(state) {
					cancel();
					var canceled = false;
					cancel = function() { canceled = true; }

					el.textContent = '–';
					var newOptions = { ...options };
					if(state) {
						newOptions.area_id = state;
					}
					birdata.stats(stat, newOptions).then(function(result) {
						if(!canceled) {
							el.textContent = util.formatNumber(result[stat]);
						}
					});
				}
				eventBus.sub('state-selected-' + options.state_menu, onChange);
				delete options.state_menu;
				onChange();
			})();
		} else {
			// Show an individual stat
			birdata.stats(stat, options).then(function(result) {
				el.textContent = util.formatNumber(result[stat]);
			});
		}
	});
}
